import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { hasAnalyticsConsent } from "@/lib/cookieConsent";

const SESSION_KEY = "nb_session_id";

const getSessionId = (): string => {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

const getUTM = () => {
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source"),
    utm_medium: p.get("utm_medium"),
    utm_campaign: p.get("utm_campaign"),
  };
};

export const usePageViewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    if (location.pathname.startsWith("/admin-login")) return;

    const record = async () => {
      try {
        // GDPR: only record server-side page views when analytics consent is granted
        if (!hasAnalyticsConsent()) return;


        const { data: { user } } = await supabase.auth.getUser();
        const utm = getUTM();
        await supabase.from("page_views" as any).insert({
          path: location.pathname,
          referrer: document.referrer || null,
          session_id: getSessionId(),
          user_id: user?.id ?? null,
          user_agent: navigator.userAgent.slice(0, 500),
          language: document.documentElement.lang || navigator.language,
          ...utm,
        });
      } catch {
        // silent
      }
    };

    record();
  }, [location.pathname]);
};

export const PageViewTracker = () => {
  usePageViewTracking();
  return null;
};
